
import '../../vendor/modaal/modaal.min@0.4.4';
function setupModaals() {
    $('[data-modaal-swiper]').click(function(e) {
        e.preventDefault();
    });
    $('[data-modaal-swiper]').each(function() {
        var modaal = this;
        var id = $(modaal).attr('href');
        $(modaal).modaal({
            content_source: id,
            type: 'inline',
			animation: 'fade',
			custom_class: 'product-detail-image__modal',
            after_open: function() {
                $(modaal).hide();
                $(window).trigger('reinit-swiper');
            },
            after_close: function() {
                $(modaal).show();
                $(window).trigger('reinit-swiper');
            }
        });
    });


    $('[data-open-modaal]').each(function() {
		var $element = $(this);
        var source = $(this).attr('data-modaal-content-source');
        var animation = $(this).attr('data-modaal-animation');
        var customClass = $(this).attr('data-modaal-custom-class');
        var locked = typeof(isLocked) !== 'undefined' && isLocked.length > 0 ? isLocked == 'true' : false;
        var disableClose = typeof(hideClose) !== 'undefined' &&  hideClose.length > 0 ? hideClose == 'true' : false;
        $element.modaal({
            content_source : source,
            hide_close: disableClose,
            is_locked: locked,
            animation : animation,
            custom_class : customClass,
			after_open: function(wrapper){
				wrapper.one("click", "[data-delegated-close-modaal]",  function() {
					$element.modaal('close');
					wrapper.off("click");
				});
			}
        });

        $(source).find('[data-modaal-close]').click(function(){
            $element.modaal('close');
        });
    });


    $('[data-opened-modaal]').each(function() {
        var animation = $(this).attr('data-modaal-animation');
        var source = $(this).attr('data-modaal-content-source');
        var customClass = $(this).attr('data-modaal-custom-class');
        var isLocked = $(this).attr('data-modaal-is-locked');
        var hideClose = $(this).attr('data-modaal-hide-close');
        var locked = typeof(isLocked) !== 'undefined' && isLocked.length > 0 ? isLocked == 'true' : false;
        var disableClose = typeof(hideClose) !== 'undefined' &&  hideClose.length > 0 ? hideClose == 'true' : false;

        $(this).modaal({
            animation : animation,
            hide_close: disableClose,
            is_locked: locked,
            content_source: source,
            custom_class : customClass
        });

        $(this).modaal('open');
    });
}

export default function () {
    setupModaals();
}



// WEBPACK FOOTER //
// ./client/src/core/components/modaal/modaal.js